<template>
      <teleport to="body">
            <div v-if="loader" id="loader">
                  <div class="loader"></div>
            </div>
      </teleport>  
</template>

<script>
export default {
  props: {
    loader: {
      type: Boolean,
      required: true
    }

  },
  
};
</script>

<style scoped>

      #loader {
            position: fixed;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-color: white;
            opacity: 0.75;
            z-index: 999;
      }

      .loader {
            width: 8px;
            height: 40px;
            border-radius: 4px;
            display: block;
            z-index: 999;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #FF3D00;
            color: #fff;
            box-sizing: border-box;
            animation: animloader 0.3s 0.3s linear infinite alternate;
      }

      .loader::after, .loader::before {
            content: '';
            width: 8px;
            height: 40px;
            border-radius: 4px;
            background: #FF3D00;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 20px;
            box-sizing: border-box;
            animation: animloader 0.3s  0.45s  linear infinite alternate;
      }
      .loader::before {
            left: -20px;
            animation-delay: 0s;
      }

      @keyframes animloader {
            0%   { height: 48px} 
            100% { height: 4px}
      }



</style>